import { Button, Checkbox, FormControlLabel, Stack } from "@mui/material";
import { Choice } from "../../../../apis/copilot/types";
import { useState } from "react";
import { ReasoningTooltip } from "../ReasoningTooltip";

interface Props {
  choices: Choice[];
  onInsert: (selectedItems: string[]) => void;
  target: string;
}

export const MultiSelect: React.FC<Props> = ({ choices, onInsert, target }) => {
  const [selectedItems, setSelectedItems] = useState<string[]>([]);
  const [isDisabled, setIsDisabled] = useState(false);

  const handleOnSelectAll = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      setSelectedItems(choices.map(({ id }) => id));
    } else {
      setSelectedItems([]);
    }
  };

  const handleItemsSelectionChange =
    (selectedItem: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
      const updated = event.target.checked
        ? [...selectedItems, selectedItem]
        : selectedItems.filter((id) => id !== selectedItem);

      setSelectedItems(updated);
    };

  return (
    <>
      <Stack direction="column" id="copilot-checkboxes-container">
        <FormControlLabel
          key="select-all"
          control={
            <Checkbox
              id="copilot-select-all-checkbox"
              checked={selectedItems.length === choices.length}
              onChange={handleOnSelectAll}
            />
          }
          label="Select All"
          disabled={isDisabled}
        />
        {choices.map(({ id, name, reason }) => (
          <FormControlLabel
            key={id}
            sx={{ marginLeft: "5px" }}
            control={
              <Checkbox
                id={`copilot-checkbox-${id}`}
                checked={selectedItems.includes(id)}
                onChange={handleItemsSelectionChange(id)}
              />
            }
            label={<ReasoningTooltip reason={reason} label={name} />}
            disabled={isDisabled}
          />
        ))}
      </Stack>

      <Button
        id="copilot-merge-button"
        variant="outlined"
        color="primary"
        disabled={selectedItems.length === 0 || isDisabled}
        onClick={() => {
          setIsDisabled(true);
          onInsert(selectedItems);
        }}
      >
        {`merge${isDisabled ? "d" : ""} into ${target}`}
      </Button>
    </>
  );
};
